import styled from 'styled-components';
import DcotorCallSvg from '../../assets/amenities/doctor-on-call.svg';

const DcotorCallIcon = styled(DcotorCallSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default DcotorCallIcon;
